'use strict'

export default class User {
    constructor(
        gender="",
        fullname="",
        phone="",
        username = "",
        address = "",
        email = "",
        password = "",
        ocupation = []
    ) {
        this.fullname=fullname
        this.gender=gender
        this.phone=phone
        this.username = username
        this.address = address
        this.email = email
        this.password = password
        this.ocupation = ocupation
    }

}

